import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Tag, Radio } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
class Filters extends React.Component {


    handleChange = (option) => {

        this.props.onChange("idCliente", option.key, "cliente", option.label[2].split('-')[0]);
        //this.props.onChange("cliente", option.label[2])
    }


    handleChangeEstado = (option) => {

        this.props.onChange("IdEstado", option.key, "estado", option.label[2].split('-')[0]);
        //this.props.onChange("cliente", option.label[2])
    }

    render() {
        return (
            <div className="filfer-container">

                {this.props.isCabecera ? (
                    <Row gutter={16}>

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Input
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.serie}
                                onChange={(e) => this.props.onChange("serie", e.target.value, null, null)}
                                onKeyUp={this.props.onKeyUpSearch}
                                placeholder="Filtrar Nro Planilla"
                                autoComplete="off"
                            />
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idEstablecimiento ?
                                        { key: this.props.filter.idEstablecimiento } : undefined
                                }
                                disabled={this.props.isDisabled}
                                placeholder={<SelectPlaceHolder label="Filtrar por Establecemiento" />}
                                onChange={(option) => this.props.onChange("idEstablecimiento", option.key, option.label[2].split('-')[0], 'establecemiento')}
                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.establecimientos.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                                ))}
                            </Select>
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idCaja ?
                                        { key: this.props.filter.idCaja } : undefined
                                }
                                disabled={this.props.isDisabled}

                                placeholder={<SelectPlaceHolder label="Filtrar por Caja" />}
                                onChange={(option) => this.props.onChange("idCaja", option.key, option, 'caja')}
                                //STATE PROPERTY     
                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.caja.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                        {/*       <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idResonsable ?
                                        { key: this.props.filter.idResonsable } : undefined
                                }
                                disabled={this.props.isDisabled}

                                placeholder={<SelectPlaceHolder label="Filtrar por Resp. Caja" />}
                                onChange={(option) => this.props.onChange("idResonsable", option.key, option, 'responsable')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.estado.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col> */}

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.IdEstado ?
                                        { key: this.props.filter.IdEstado } : undefined
                                }
                                disabled={this.props.isDisabled}

                                placeholder={<SelectPlaceHolder label="Filtrar por Estado" />}
                                onChange={(option) => this.props.onChange("IdEstado", option.key, option, 'estado')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.estado.map(item => ( //STATE DATA
                                    item.abreviatura != "R" ?
                                        <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                        : null
                                ))}
                            </Select>
                        </Col>


                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha inicio"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaInicioStr', value, null, null)}
                            />
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha fin"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaFinStr', value, null, null)}
                            />
                        </Col>


                    </Row>

                ) :
                    <Row gutter={16}>

                        <Col className="gutter-row" sm={24} md={12} lg={7}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idCliente ?
                                        { key: this.props.filter.idCliente } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Cliente" />}
                                onChange={(option) => this.props.onChange("idCliente", option.key, option, 'Cliente')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.clientes.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id} name={item.tipoDocumento} > <Tag>{item.tipoDocumento}</Tag>{`${item.nombre}-${item.numeroDocumento}`}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idTipoComprobante ?
                                        { key: this.props.filter.idTipoComprobante } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Comprobante" />}
                                onChange={(option) => this.props.onChange("idTipoComprobante", option.key, option, 'Comprobante')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.comprobantes.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idFormaPago ?
                                        { key: this.props.filter.idFormaPago } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Forma Pago" />}
                                onChange={(option) => this.props.onChange("idFormaPago", option.key, option, 'FormaPago')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                <Select.Option value={"0"} key={"0"}  >Todos</Select.Option>

                                {this.props.listaFormaPago.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <Input
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.serie}
                                onChange={(e) => this.props.onChange("serie", e.target.value, null, null)}
                                onKeyUp={this.props.onKeyUpSearch}
                                placeholder="Filtrar por Serie"
                                autoComplete="off"
                            />
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <Input
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.documento}
                                onChange={(e) => this.props.onChange("documento", e.target.value, null, null)}
                                onKeyUp={this.props.onKeyUpSearch}
                                placeholder="Filtrar por Nro Documento"
                                autoComplete="off"
                            />
                        </Col>

                        {/*           <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha inicio"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaInicioStr', value, null, null)}
                            />
                        </Col> */}
                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaFinStr', value, null, null)}
                            />
                        </Col>

                        {this.props.isPlanilla ?
                            (
                                <div>


                                    <Col className="gutter-row" sm={24} md={24} lg={4}>
                                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                            <Radio.Group
                                                value={this.props.filter.tipoReporte}
                                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value, null, null)}
                                            >
                                                <Radio value={1}>Resumen</Radio>
                                                <Radio value={2}>Detallado</Radio>
                                            </Radio.Group>
                                        </div>
                                    </Col>
                                </div>
                            ) : null
                        }




                    </Row>

                }

            </div>
        );
    }

}

export default Filters;